import { Box, Flex, Image, Stack, useDisclosure } from '@chakra-ui/react';
import { FaBars } from 'react-icons/fa';
import MenuMobile from './MenuMobile';
import ProfileWeb from './ProfileWeb';
import Navbar from './Navbar';
import { useNavigate } from 'react-router-dom';
import { memo } from 'react';
import { useGetClientData } from '../../services/hooks/ClientData/useGetClientData';
import { IoArrowBackOutline } from 'react-icons/io5';

interface IOwnProps {
  showGoBack?: boolean;
}

const Header: React.FC<IOwnProps> = ({ showGoBack }) => {
  const navigation = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const ClientData = useGetClientData();

  return (
    <Stack
      height={['70px', '70px', '80px', '85px']}
      zIndex={99}
      align="center"
      justify="space-between"
      bg="white"
      pr="15px"
      flexDir="row"
      boxShadow="none"
      w="100%"
    >
      <Flex mx={['5px', '10px', '15px', '24px', '30px']} align="center">
        {showGoBack && (
          <Box pr={3} pl={2} onClick={() => navigation(-1)}>
            <IoArrowBackOutline size={25} />
          </Box>
        )}
        <Box width={['100px', '100px', '125px', '145px']}>
          <Image cursor="pointer" src={ClientData?.data?.main_logo} alt="logo" py={1} onClick={() => navigation('/')} />
        </Box>
      </Flex>

      <Flex w="100%" align="center" h="100%" justifyContent="space-between">
        <Navbar />

        <ProfileWeb />

        <Stack
          w="100%"
          display={['flex', 'flex', 'flex', 'none', 'none']}
          align="flex-end"
          justifyContent="center"
          cursor="pointer"
          onClick={onOpen}
        >
          <FaBars size={25} />
        </Stack>
      </Flex>

      <MenuMobile {...{ isOpen, onClose }} />
    </Stack>
  );
};

export default memo(Header);
